import { render, staticRenderFns } from "./BadgeRenderer.vue?vue&type=template&id=0d0c7792&"
import script from "./BadgeRenderer.vue?vue&type=script&lang=ts&"
export * from "./BadgeRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports